import { NgModule} from '@angular/core';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {TokeninterceptorService} from './tokeninterceptor.service';

@NgModule({
  imports: [HttpClientModule],
  providers: [
  TokeninterceptorService,
  {provide: HTTP_INTERCEPTORS, useClass: TokeninterceptorService, multi: true
  }
  ]
  })
export class httpinterceptorModule { }
